import { render, staticRenderFns } from "./CoverSpin.vue?vue&type=template&id=752d9bfe&scoped=true&"
import script from "./CoverSpin.vue?vue&type=script&lang=js&"
export * from "./CoverSpin.vue?vue&type=script&lang=js&"
import style0 from "./CoverSpin.vue?vue&type=style&index=0&id=752d9bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752d9bfe",
  null
  
)

export default component.exports